import PropTypes from 'prop-types'
import { QueryErrorResetBoundary } from 'react-query'
import { ErrorBoundary } from 'react-error-boundary'

import CaughtError from './CaughtError'

const ErrorRawBoundary = ({ children, ...rest }) => (
  <QueryErrorResetBoundary>
    {({ reset }) => (
      <ErrorBoundary
        FallbackComponent={CaughtError}
        onReset={reset}
        onError={(error, info) => {
          // TODO: Log to Sentry?
        }}
        {...rest}
      >
        {children}
      </ErrorBoundary>
    )}
  </QueryErrorResetBoundary>
)

ErrorRawBoundary.propTypes = {
  children: PropTypes.node,
}

export default ErrorRawBoundary
